import { useCallback, useRef } from 'react';

import { BackHandler, NativeEventSubscription } from 'react-native';

import { useFocusEffect } from '@react-navigation/native';

import { isWeb } from 'utils/responsiveness';

type CallbackFunction = () => void;

const useHardwareBackPressHandler = (callback?: CallbackFunction) => {
    const subscription = useRef<NativeEventSubscription | undefined>(undefined);

    useFocusEffect(
        useCallback(() => {
            const onBackPress = () => {
                if (callback) {
                    callback(); // Execute the callback instead of navigation.goBack()
                    return true; // Stop default back navigation
                }

                return false; // Keep default back navigation
            };

            if (!isWeb) {
                subscription.current = BackHandler.addEventListener(
                    'hardwareBackPress',
                    onBackPress,
                );
            }

            return () => {
                if (!isWeb && subscription.current) {
                    subscription.current.remove();
                    subscription.current = undefined;
                }
            };
        }, [callback]),
    );
};

export default useHardwareBackPressHandler;
